import Vue from 'vue';
import Vuex from 'vuex';
import { resetRouter } from '@/router';
import Local from '@/utils/local';
import { getToken, removeToken } from '@/utils/token';
import { getUser, removeUser } from '@/utils/user';
import { removePage } from '@/utils/page';
import { removeSearch } from '@/utils/search';

Vue.use(Vuex);

const collapse = Local.get('isCollapse');

export default new Vuex.Store({
  state: {
    token: getToken(), // token
    user: getUser() || {}, // 用户信息
    homeMenu: [], // 首页菜单数据
    menu: [], // 菜单数据
    readOnly: [], // 页面权限
    open: collapse ? !!+collapse : true, // 侧边栏是否展开
    withoutAnimation: false, // 是否有动画
    device: 'desktop', // 显示设备
    isLogout: false, // 是否是登录后退出
    isIframe: false // 是否是第三方系统嵌入
  },
  mutations: {
    // 设置 token
    SET_TOKEN(state, token) {
      state.token = token;
    },
    // 设置用户信息
    SET_USER(state, user) {
      state.user = user;
    },
    // 设置首页菜单
    SET_HOME_MENU(state, menu) {
      state.homeMenu = menu;
    },
    // 设置菜单
    SET_MENU(state, menu) {
      state.menu = menu;
    },
    // 设置页面只读权限
    SET_READ_ONLY(state, readonly) {
      state.readOnly = [...state.readOnly, ...readonly];
    },
    // 重置页面只读权限
    RESET_READ_ONLY(state) {
      state.readOnly = [];
    },
    // 切换侧边栏
    TOGGLE_SIDEBAR(state) {
      state.open = !state.open;
      state.withoutAnimation = false;
      Local.set('isCollapse', +state.open);
    },
    // 关闭侧边栏
    CLOSE_SIDEBAR(state, bool) {
      Local.set('isCollapse', 0);
      state.open = false;
      state.withoutAnimation = bool;
    },
    // 切换显示设备
    TOGGLE_DEVICE(state, device) {
      state.device = device;
    },
    // 设置退出
    SET_LOGOUT(state, bool) {
      state.isLogout = bool;
    },
    // 设置第三方系统嵌入
    SET_IS_IFRAME(state, bool) {
      state.isIframe = bool;
    }
  },
  actions: {
    // 提交设置 token
    setToken({ commit }, token) {
      commit('SET_TOKEN', token);
    },
    // 提交设置用户信息
    setUser({ commit }, user) {
      commit('SET_USER', user);
    },
    // 提交清除 token
    resetToken({ commit }) {
      commit('SET_TOKEN', '');
      commit('SET_USER', {});
      commit('SET_MENU', []);
      commit('RESET_READ_ONLY');
      commit('SET_LOGOUT', true);
      removeToken();
      removeUser();
      resetRouter();
      removePage();
      removeSearch();
    },
    // 提交设置首页菜单
    setHomeMenu({ commit }, menu) {
      commit('SET_HOME_MENU', menu);
    },
    // 提交设置菜单
    setMenu({ commit }, menu) {
      commit('SET_MENU', menu);
    },
    // 提交设置页面只读权限
    setReadOnly({ commit }, readonly) {
      commit('SET_READ_ONLY', readonly);
    },
    // 切换侧边栏
    toggleSidebar({ commit }) {
      commit('TOGGLE_SIDEBAR');
    },
    // 提交关闭侧边栏
    closeSidebar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation);
    },
    // 提交切换显示设备
    toggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device);
    },
    // 提交设置退出
    setLogout({ commit }, bool) {
      commit('SET_LOGOUT', bool);
    },
    // 提交设置第三方系统嵌入
    setIsIframe({ commit }, bool) {
      commit('SET_IS_IFRAME', bool);
    }
  },
  getters: {
    token: state => state.token,
    user: state => state.user,
    menu: state => state.menu,
    homeMenu: state => state.homeMenu,
    readOnly: state => state.readOnly,
    hasToken: state => state.token,
    open: state => state.open,
    withoutAnimation: state => state.withoutAnimation,
    device: state => state.device
  },
  modules: {}
});
